<template>
  <div class="infoPage">
    <el-card style="margin: 30px;min-height: 1100px">
      <div style="display: flex;align-items: center">
        <div>资讯标题：</div>
        <el-input clearable placeholder="请输入搜索内容" size="small" style="width: 180px;margin-right: 10px"
                  v-model="newsTitle"></el-input>
        <div>审核状态：</div>
        <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable
                   placeholder="请选择审核状态">
          <el-option
              v-for="item in [{'key':3,'value':'待审核'},{'key':1,'value':'审核通过'},{'key':4,'value':'审核未通过'}]"
              :key="item.key"
              :label="item.value"
              :value="item.key">
          </el-option>
        </el-select>
        <div>创建时间：</div>
        <el-date-picker
            v-model="dateValue"
            :clearable="false"
            @change="dateChange"
            type="daterange"
            size="small"
            style="margin-right: 10px"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
        <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
        <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
        <el-button size="small" type="success" @click="addBtn">新增</el-button>
      </div>

      <el-table
          size="small"
          tooltip-effect="dark"
          ref="multipleTable"
          :data="tableData"
          border
          style="width: 100%;margin-top: 30px"
      >
        <el-table-column label="资讯标题" prop="newsTitle" align="center"></el-table-column>
        <el-table-column label="资讯来源" width="200" prop="source" align="center"></el-table-column>
        <el-table-column label="封面图类型" width="100" prop="" align="center">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.frontCoverType === 1 ? '一张小图' : scope.row.frontCoverType === 2 ? '三张小图' : scope.row.frontCoverType === 3 ? '一张大图' : ''
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="新闻类型" width="100" align="center">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.type === '1' ? '普通新闻' : scope.row.type === '2' ? '视频新闻' : scope.row.type === '3' ? '图集新闻' : ''
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="阅读数" width="80" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.watchCount ? scope.row.watchCount : 0 }}</div>
          </template>
        </el-table-column>
        <el-table-column label="点赞数" width="80" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.favorCount ? scope.row.favorCount : 0 }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="120" align="center">
          <template slot-scope="scope">
            <a-tooltip placement="right" trigger="click">
              <template slot="title">
                {{ scope.row.createDate }}
              </template>
              {{ scope.row.createDateList&&scope.row.createDateList.length?scope.row.createDateList[0]:''}}
            </a-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="100" align="center">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;justify-content: center">
              <el-tag v-if="scope.row.examineStatus === '2' || scope.row.examineStatus === '3'" type="warning"
                      size="small" effect="dark">待审核
              </el-tag>
              <el-tag v-else-if="scope.row.examineStatus === '1'" type="success" size="small" effect="dark">审核通过
              </el-tag>
              <el-tag v-else-if="scope.row.examineStatus === '4'" type="danger" size="small" effect="dark">审核未通过
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            width="200"
            label="操作"
        >
          <template slot-scope="scope">
            <el-button @click="viewBtn(scope.row)" size="small" type="success">预览</el-button>
            <el-button @click="editBtn(scope.row)" size="small" type="success">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          style="display: flex;justify-content: center;margin-top: 20px"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[20, 30, 40, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalElements">
      </el-pagination>
    </el-card>

    <a-modal
        :keyboard="false"
        :maskClosable="false"
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="900px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="资讯类型" prop="type">
          <el-select :disabled="dialogTitle === '编辑资讯'" @change="typeChange" v-model="ruleForm.type" size="small"
                     style="width: 300px;"
                     placeholder="请选择资讯类型">
            <el-option
                v-for="item in [{'key':'1','value':'普通新闻'},{'key':'2','value':'视频新闻'},{'key':'3','value':'图集新闻'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面类型" prop="type">
          <el-select @change="coverTypeChange" v-model="ruleForm.frontCoverType" size="small" style="width: 300px;"
                     placeholder="请选择封面类型">
            <el-option
                v-for="item in [{'key':1,'value':'一张小图'},{'key':2,'value':'三张小图'},{'key':3,'value':'一张大图'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资讯标题" prop="newsTitle">
          <el-input v-model="ruleForm.newsTitle" style="width: 600px" size="small" placeholder="请输入资讯标题"></el-input>
        </el-form-item>
        <el-form-item label="资讯来源" prop="source">
          <el-input v-model="ruleForm.source" style="width: 600px" size="small" placeholder="请输入资讯来源"></el-input>
        </el-form-item>
        <el-form-item label="资讯摘要" prop="zhaiyao">
          <el-input v-model="ruleForm.zhaiyao" type="textarea" :rows="3" style="width: 600px" size="small"
                    placeholder="请输入资讯摘要"></el-input>
        </el-form-item>
        <el-form-item label="封面图片" prop="coverCheck">
          <el-upload
              :action="uploadApiUrl"
              :file-list="coverUrlList"
              list-type="picture-card"
              :class="{ disabled: uploadDisabled }"
              :limit="limitCoverCount"
              :on-success="handleAvatarSuccess"
              :on-change="handleChange"
              :on-remove="handleRemove"
              :multiple="ruleForm.frontCoverType === 2">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="ruleForm.type === '1'" label="资讯内容" prop="newsContent">
          <quill-editor ref="myQuillEditor" style="width: 700px;height: 400px;padding-bottom: 200px"
                        v-model="ruleForm.newsContent" :options="editorOption"/>
            <el-dialog
                v-if="videoUploadTag"
                :visible.sync="videoUploadTag"
                append-to-body
                id="video_upload"
                style="margin-top: 1px"
                title="视频上传"
                width="50%"
            >
              <a-upload
                  :action="serverUrl"
                  name="img"
                  ref="upload"
                  :supportServerRender="true"
                  :preview-file="previewFile"
                  @change="videoChange"
              >
                <a-button type="primary"> <a-icon type="upload"/> 上传视频 </a-button>
              </a-upload>
            </el-dialog>
        </el-form-item>
        <el-form-item v-if="ruleForm.type === '2'" label="上传视频" prop="videoUrl">
<!--          <el-upload-->
<!--              class="upload-demo"-->
<!--              :action="uploadFileUrl"-->
<!--              :on-success="videoUploadSuccess"-->
<!--              :on-remove="videoUploadRemove"-->
<!--              multiple-->
<!--              :file-list="videoData"-->
<!--              :limit="1">-->
<!--            <el-button size="small" type="primary">点击上传</el-button>-->
<!--          </el-upload>-->
          <div v-if="ruleForm.videoUrl" style="display: flex;align-items: center">
            <video
                :src="ruleForm.videoUrl"
                controls="controls"
                style="width:240px;height:120px"
            ></video>
            <el-button @click="chooseVideoBtn" style="margin-left: 5px;" type="danger" size="mini">删除</el-button>
          </div>

          <a-upload v-else
                    :action="uploadFileUrl"
                    ref="upload"
                    :supportServerRender="true"
                    @change="videoUploadChange"
          >
            <a-button type="primary"> <a-icon type="upload"/>上传视频</a-button>
          </a-upload>


        </el-form-item>
        <el-form-item v-if="ruleForm.type === '2'" label="视频说明" prop="videoContent">
          <el-input v-model="ruleForm.videoContent" type="textarea" :rows="3" style="width: 600px" size="small"
                    placeholder="请输入视频说明"></el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.type === '3'" label="上传图集" prop="imagesCheck">
          <el-upload
              class="upload-demo"
              :action="uploadApiUrl"
              multiple
              :limit="5"
              :on-success="imageSuccess"
              :on-remove="imageRemove"
              :file-list="imageData">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>

        <div style="margin-left: 100px" v-if="ruleForm.newsImgSubList && ruleForm.newsImgSubList.length">
          <div v-for="(item,index) in ruleForm.newsImgSubList" :key="index">
            <div style="display: flex;margin: 10px">
              <el-image
                  style="width: 90px; height: 90px;margin-right: 20px"
                  :src="item.imgUrl"></el-image>
              <el-form-item style="margin-left: -100px" :prop="`newsImgSubList[${index}].imgText`"
                            :rules="{ required: true, message: '请输入图片说明', trigger: 'blur' }">
                <el-input v-model="item.imgText" type="textarea" :rows="4" style="width: 400px;" size="small"
                          placeholder="请输入图片说明"></el-input>
              </el-form-item>
              <el-form-item style="margin-left: -80px;margin-top: 24px" :prop="`newsImgSubList[${index}].sort`"
                            :rules="{ required: true, message: '请输入排序值', trigger: 'blur' }">
                <el-input-number :min="0" v-model="item.sort"></el-input-number>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </a-modal>

  </div>
</template>

<script>
import moment from "moment";
import {baseURL} from "@/api/config";
import 'quill/dist/quill.snow.css'
import {Quill, quillEditor} from 'vue-quill-editor'
import {container, ImageExtend, QuillWatch} from 'quill-image-extend-module'
import * as imageConversion from "image-conversion";
import axios from "axios";

Quill.register('modules/ImageExtend', ImageExtend)

export default {
  components: {quillEditor},
  data() {
    var self2 = this;
    let valiIcon = (rule, value, callback) => {
      if (this.ruleForm.frontCoverType === 1 || this.ruleForm.frontCoverType === 3) {
        if (this.coverUrlList.length < 1) {
          callback(new Error('请至少上传一张上传封面图'))
        } else {
          callback()
        }
      } else if (this.ruleForm.frontCoverType === 2) {
        if (this.coverUrlList.length < 3) {
          callback(new Error('请至少上传三张封面图'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    let valiImages = (rule, value, callback) => {
      if (this.imageData.length < 1) {
        callback(new Error('请至少上传一张上传图片'))
      } else {
        callback()
      }
    }
    return {
      pageNum: 1,
      pageSize: 20,
      newsTitle: '',
      examineStatus: null,
      dateValue: '',
      createStartDate: '',
      createEndDate: '',
      tableData: [],
      totalElements: 0,
      addDialogState: false,
      dialogTitle: '',
      uploadApiUrl: '',
      uploadFileUrl: '',
      ruleForm: {
        id: null,
        type: '1',
        frontCoverType: 1,
        newsTitle: '',
        source: '',
        zhaiyao: '',
        coverCheck: '',
        coverList: [],
        newsContent: '',
        videoUrl: '',
        videoContent: '',
        newsImgSubList: [],
        imagesCheck: ''
      },
      rules: {
        type: [{required: true, message: "请选择资讯类型", trigger: "blur"}],
        frontCoverType: [{required: true, message: "请选择封面类型", trigger: "blur"}],
        newsTitle: [{required: true, message: "请输入资讯标题", trigger: "blur"}],
        source: [{required: true, message: "请输入资讯来源", trigger: "blur"}],
        zhaiyao: [{required: true, message: "请输入资讯摘要", trigger: "blur"}],
        coverCheck: [{required: true, validator: valiIcon}],
        imagesCheck: [{required: true, validator: valiImages}],
        newsContent: [{required: true, message: "请输入资讯内容", trigger: "blur"}],
        videoUrl: [{required: true, message: "请上传视频", trigger: "blur"}],
        videoContent: [{required: true, message: "请输入视频说明", trigger: "blur"}],
      },
      limitCoverCount: 1,
      currentCoverCount: 0,
      uploadDisabled: false,
      coverUrlList: [],
      editorOption: {
        placeholder: '请输入资讯内容',
        modules: {
          ImageExtend: {
            loading: true,
            name: 'file',
            action: '',
            response: (res) => {
              if (res.success) {
                return res.entity
              }
            }
          },
          toolbar: {
            container: container,
            handlers: {
              image: function () {
                QuillWatch.emit(this.quill.id)
              },
              video: function (value) {
                if (value) {
                  self2.videoUploadTag = true;
                } else {
                  this.quill.format("image", false);
                }
              }
            }
          }
        }
      },
      imageData: [],
      // videoData: [],
      id: null,
      videoUploadTag: null,
      serverUrl: baseURL + "/file/uploadFile",
    }
  },
  created() {
    this.uploadApiUrl = baseURL + '/file/uploadUserHeadImg'
    this.uploadFileUrl = baseURL + '/file/uploadFile/v2'
    this.editorOption.modules.ImageExtend.action = this.uploadApiUrl
    this.getList();
  },
  methods: {
    chooseVideoBtn(){
      this.ruleForm.videoUrl = null
    },
    videoUploadChange(file) {
      console.log(file,9999)
      if(file.file.response && file.file.response.entity){
        console.log('上传成功',file.file.response.entity)
        this.ruleForm.videoUrl = file.file.response.entity
      }
    },
    videoSelectTagClick() {}, //视频链接
    previewFile(file) {
      // console.log(file);
    },
    videoChange(file, fileList, event) {
      if(file.file.response&&file.file.response.entity){
        this.insertEle("video", file.file.response.entity); //方法，插入图片到富文本
      }
    },
    insertEle(type, url) {
      let quill = this.$refs.myQuillEditor.quill;
      //  当编辑器中没有输入文本时，这里获取到的 range 为 null
      var range = this.$refs.myQuillEditor.quill.getSelection();
      // 视频插入在富文本中的位置
      var index = 0;
      if (range == null) {
        index = 0;
      } else {
        index = range.index;
      }
      // 插入视频  response.data.url为服务器返回的图片地址
      if (type === "video") {
        this.$refs.myQuillEditor.quill.insertEmbed(index, "simpleVideo", {
          url,
          controls: "controls",
          width: "100%",
          height: "200px",
          poster: url + "?x-oss-process=video/snapshot,t_1,f_jpg,m_fast",
        });
      }
      // 调整光标到最后
      this.$refs.myQuillEditor.quill.setSelection(index + 1);
      this.videoUploadTag = false;
    },
    uploadSuccess(res) {  //把已经上传的图片显示回富文本编辑框中
      //res返回的格式是{url:"图片的路径"}，这个是后台接口返回的
      let quill = this.$refs.myQuillEditor.quill
      quill.focus();
      quill.insertEmbed(quill.getSelection().index, 'image', res.entity);
    },
    beforeVideoUpload(file) {
      console.log('file', file)
      const isVideo = file.type === 'video/mp4';
      if (!isVideo) {
        this.$message.error('只能上传视频文件');
      }
      return isVideo;
    },
    // videoUploadSuccess(res) {
    //   console.log(res, 9999)
    //   if (res.success) {
    //     this.ruleForm.videoUrl = res.entity
    //   }
    // },
    imageSuccess(res, file, fileList) {
      this.ruleForm.newsImgSubList = []
      this.imageData = fileList
      console.log(this.imageData, 'imageSuccess')
      if (this.imageData && this.imageData.length) {
        this.imageData.forEach((item) => {
          if (item.response) {
            this.ruleForm.newsImgSubList.push({'imgUrl': item.response.entity, 'imgText': '', 'sort': 0})
          } else {
            this.ruleForm.newsImgSubList.push({'imgUrl': item.url, 'imgText': item.content, 'sort': item.sort})
          }
        })
      }
    },
    imageRemove(file, fileList) {
      this.ruleForm.newsImgSubList = []
      this.imageData = fileList
      console.log('imageRemove', this.imageData)
      if (this.imageData && this.imageData.length) {
        this.imageData.forEach((item) => {
          if (item.response) {
            this.ruleForm.newsImgSubList.push({'imgUrl': item.response.entity, 'imgText': '', 'sort': 0})
          } else {
            this.ruleForm.newsImgSubList.push({'imgUrl': item.url, 'imgText': item.content, 'sort': item.sort})
          }
        })
      }
    },
    // videoUploadRemove() {
    //   this.videoData = []
    //   this.ruleForm.videoUrl = ''
    // },
    getList() {
      this.postAxios("/news/list", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        newsTitle: this.newsTitle,
        examineStatus: this.examineStatus,
        createTimestampStart: this.createStartDate,
        createTimestampEnd: this.createEndDate,
      }).then(res => {
        if (res.success) {
          this.tableData = res.content
          this.totalElements = res.totalCount
          this.tableData.forEach((item) => {
            if(item.createDate){
              item.createDateList = item.createDate.split(' ')
            }
          })
        }
      })
    },
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.newsTitle = ''
      this.examineStatus = null
      this.createStartDate = ''
      this.createEndDate = ''
      this.dateValue = ''
      this.getList()
    },
    addBtn() {
      this.dialogTitle = '新增资讯'
      this.uploadDisabled = false
      this.id = null
      this.ruleForm.newsTitle = ''
      this.ruleForm.source = ''
      this.ruleForm.zhaiyao = ''
      this.coverUrlList = []
      this.ruleForm.coverList = []
      this.ruleForm.newsContent = ''
      this.ruleForm.videoUrl = ''
      this.ruleForm.videoContent = ''
      this.ruleForm.newsImgSubList = []
      this.addDialogState = true
      setTimeout(() => {
        let quill = this.$refs.myQuillEditor.quill;
        quill.root.addEventListener(
            "paste",
            (evt) => {
              if (
                  evt.clipboardData &&
                  evt.clipboardData.files &&
                  evt.clipboardData.files.length
              ) {
                evt.preventDefault();
                [].forEach.call(evt.clipboardData.files, (file) => {
                  if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
                    return;
                  }
                  console.log('file',file)
                  imageConversion.compressAccurately(file, 500).then(res => {
                    const formData = new FormData();
                    formData.append("file", res);
                    axios.post(this.uploadApiUrl, formData).then(res => {
                      console.log('res', res)
                      let length = quill.getSelection().index; //光标位置
                      // 插入图片地址
                      quill.insertEmbed(length, "image", res.entity);
                      // 光标后移一位
                      quill.setSelection(length + 1);
                    });
                  });

                });
              }
            },
            false
        );
      }, 300)
    },
    viewBtn(row) {
      this.$router.push({
        path: "/previewPage", query: {
          id: row.id
        }
      });
    },
    editBtn(row) {
      console.log('row', row)
      this.dialogTitle = '编辑资讯'
      this.id = row.id
      this.ruleForm.type = row.type
      this.ruleForm.frontCoverType = row.frontCoverType
      this.ruleForm.newsTitle = row.newsTitle
      this.ruleForm.source = row.source
      this.ruleForm.zhaiyao = row.zhaiyao
      this.ruleForm.newsContent = row.newsContent
      this.coverUrlList = []
      this.currentCoverCount = row.newsInfoImgList.length
      this.limitCoverCount = row.frontCoverType === 2 ? 3 : 1
      this.imageData = []
      // this.videoData = []
      this.uploadDisabled = true
      //复现封面图
      if (row.newsInfoImgList && row.newsInfoImgList.length) {
        row.newsInfoImgList.forEach((item) => {
          this.coverUrlList.push({url: item.imgUrl})
        })
      }
      //复现图集
      if (row.newsImgSubList && row.newsImgSubList.length) {
        this.ruleForm.newsImgSubList = row.newsImgSubList
        row.newsImgSubList.forEach((item) => {
          this.imageData.push({url: item.imgUrl, name: item.imgUrl, sort: item.sort, content: item.imgText})
        })
      }
      //复现视频
      if (row.newsVideo) {
        this.ruleForm.videoContent = row.newsVideo.videoText
        this.ruleForm.videoUrl = row.newsVideo.videoUrl
        // this.videoData.push({url: row.newsVideo.videoUrl, name: row.newsVideo.videoUrl})
      }
      this.addDialogState = true
    },
    // 生成海报
    poster(id) {
      this.getAxios("/news/generate/poster", {
        newsInfoId: id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    dateChange(e) {
      this.dateValue = e
      this.createStartDate = moment(this.dateValue[0]).format('YYYY-MM-DD')
      this.createEndDate = moment(this.dateValue[1]).format('YYYY-MM-DD')
    },
    typeChange() {
      this.ruleForm.newsContent = ''
      this.ruleForm.videoUrl = ''
      this.ruleForm.videoContent = ''
      this.imageData = []
      this.ruleForm.newsImgSubList = []
      this.$refs.ruleForm.clearValidate();
      if (this.ruleForm.type == 1){
        setTimeout(() => {
          let quill = this.$refs.myQuillEditor.quill;
          quill.root.addEventListener(
              "paste",
              (evt) => {
                if (
                    evt.clipboardData &&
                    evt.clipboardData.files &&
                    evt.clipboardData.files.length
                ) {
                  evt.preventDefault();
                  [].forEach.call(evt.clipboardData.files, (file) => {
                    if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
                      return;
                    }
                    console.log('file',file)
                    imageConversion.compressAccurately(file, 500).then(res => {
                      const formData = new FormData();
                      formData.append("file", res);
                      axios.post(this.uploadApiUrl, formData).then(res => {
                        console.log('res', res)
                        let length = quill.getSelection().index; //光标位置
                        // 插入图片地址
                        quill.insertEmbed(length, "image", res.entity);
                        // 光标后移一位
                        quill.setSelection(length + 1);
                      });
                    });

                  });
                }
              },
              false
          );
        }, 300)
      }
    },
    coverTypeChange(value) {
      if (this.ruleForm.frontCoverType === 1) {
        this.limitCoverCount = 1
      } else if (this.ruleForm.frontCoverType === 2) {
        this.limitCoverCount = 3
      } else if (this.ruleForm.frontCoverType === 3) {
        this.limitCoverCount = 1
      }
      this.coverUrlList = []
      this.currentCoverCount = 0
      this.uploadDisabled = false
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {}
          this.ruleForm.coverList = []
          //复现封面图，如果有编辑时上传的需要取一下response中的值
          this.coverUrlList.forEach((item) => {
            if (item.response) {
              this.ruleForm.coverList.push(item.response.entity)
            } else {
              this.ruleForm.coverList.push(item.url)
            }
          })
          if (this.dialogTitle === '新增资讯') {
            if (this.ruleForm.type === '1') {
              params = {
                newsTitle: this.ruleForm.newsTitle,
                frontCoverType: this.ruleForm.frontCoverType,
                source: this.ruleForm.source,
                type: '1',
                zhaiyao: this.ruleForm.zhaiyao,
                coverList: this.ruleForm.coverList,
                newsContent: this.ruleForm.newsContent
              }
            } else if (this.ruleForm.type === '2') {
              params = {
                newsTitle: this.ruleForm.newsTitle,
                frontCoverType: this.ruleForm.frontCoverType,
                source: this.ruleForm.source,
                type: '2',
                zhaiyao: this.ruleForm.zhaiyao,
                coverList: this.ruleForm.coverList,
                newsVideo: {
                  videoUrl: this.ruleForm.videoUrl,
                  videoText: this.ruleForm.videoContent
                }
              }
            } else if (this.ruleForm.type === '3') {
              params = {
                newsTitle: this.ruleForm.newsTitle,
                frontCoverType: this.ruleForm.frontCoverType,
                source: this.ruleForm.source,
                type: '3',
                zhaiyao: this.ruleForm.zhaiyao,
                coverList: this.ruleForm.coverList,
                newsImgSubList: this.ruleForm.newsImgSubList
              }
            }
            this.postAxios("/news/publish", params).then(res => {
              this.$message.success("添加成功!")
              this.addDialogState = false
              this.getList()
            })
          } else {
            if (this.ruleForm.type === '1') {
              params = {
                id: this.id,
                newsTitle: this.ruleForm.newsTitle,
                frontCoverType: this.ruleForm.frontCoverType,
                source: this.ruleForm.source,
                type: '1',
                zhaiyao: this.ruleForm.zhaiyao,
                coverList: this.ruleForm.coverList,
                newsContent: this.ruleForm.newsContent
              }
            } else if (this.ruleForm.type === '2') {
              params = {
                id: this.id,
                newsTitle: this.ruleForm.newsTitle,
                frontCoverType: this.ruleForm.frontCoverType,
                source: this.ruleForm.source,
                type: '2',
                zhaiyao: this.ruleForm.zhaiyao,
                coverList: this.ruleForm.coverList,
                newsVideo: {
                  videoUrl: this.ruleForm.videoUrl,
                  videoText: this.ruleForm.videoContent
                }
              }
            } else if (this.ruleForm.type === '3') {
              params = {
                id: this.id,
                newsTitle: this.ruleForm.newsTitle,
                frontCoverType: this.ruleForm.frontCoverType,
                source: this.ruleForm.source,
                type: '3',
                zhaiyao: this.ruleForm.zhaiyao,
                coverList: this.ruleForm.coverList,
                newsImgSubList: this.ruleForm.newsImgSubList
              }
            }
            this.postAxios("/news/edit", params).then(res => {
              this.$message.success("修改成功!")
              this.addDialogState = false
              this.getList()
            })
          }
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    handleChange(file, fileList) {
      this.currentCoverCount = fileList.length
      if (this.currentCoverCount === this.limitCoverCount) {
        this.uploadDisabled = true
      } else {
        this.uploadDisabled = false
      }
    },
    handleAvatarSuccess(res, file, fileList) {
      this.coverUrlList = fileList
      console.log(res, file, fileList)
    },
    handleRemove(file, fileList) {
      this.coverUrlList = fileList
      this.currentCoverCount = fileList.length
      if (this.currentCoverCount < this.limitCoverCount) {
        this.uploadDisabled = false
      } else {
        this.uploadDisabled = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>
<style>
/*去除upload组件过渡效果*/
.el-upload-list__item {
  transition: none !important;
}

.disabled .el-upload--picture-card {
  display: none !important;
}

.ql-container {
  min-height: 300px;
}

.quill-editor {
  width: 880px;
}
</style>
